/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditColumn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M2 2h2v20H2zm4 0h2v20H6zm12 18h-6V4h6v2h2V2H10v20h10v-4h-2z" />
      <path d="m21.7 11.3-3-3c-.4-.4-1-.4-1.4 0l-3 3-.3.3V16h4.4l.3-.3 3-3c.4-.4.4-1 0-1.4zM17.6 14H16v-1.6l2-2 1.6 1.6z" />
    </g>
  </Icon>
);
export { SvgEditColumn as EditColumn };
